import { useWallet } from "@/context/WalletContext";
import { useLang } from "@/context/LanguageContext";
import { shorten } from "@/lib/api";
import { Plug, LogOut } from "lucide-react";

export function WalletButton({ compact = false }) {
  const { account, connect, disconnect, connecting } = useWallet();
  const { t } = useLang();

  if (account) {
    return (
      <div className="flex items-center gap-2">
        <div
          data-testid="wallet-address-chip"
          className="font-mono text-xs px-3 py-2 border border-portal/40 text-portal bg-portal/5 flex items-center gap-2"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-portal animate-pulse" />
          {shorten(account)}
        </div>
        <button
          data-testid="wallet-disconnect-btn"
          onClick={disconnect}
          title="Disconnect"
          className="p-2 border border-cosmic/20 text-cosmic hover:text-mars hover:border-mars/50 transition-colors"
        >
          <LogOut size={14} />
        </button>
      </div>
    );
  }

  return (
    <button
      data-testid="wallet-connect-btn"
      onClick={connect}
      disabled={connecting}
      className="btn-portal flex items-center gap-2 disabled:opacity-50"
    >
      <Plug size={14} />
      {connecting ? "…" : compact ? t.nav.connectShort : t.nav.connect}
    </button>
  );
}
